import axios from 'axios';
import clearLocalStorage from '../../../util/Common/Auth/Handler/clearLocalStorage';

const refresh = async ({ originalRequest, axiosInstance }) => {
  const refreshToken = localStorage.getItem('refreshToken');
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/sign/refresh`,
      { refresh: refreshToken },
    );
    if (response.status === 200) {
      // Set localStorage items
      localStorage.setItem('accessToken', response.data.access);
      localStorage.setItem(
        'aws_credentials',
        JSON.stringify(response.data.aws_credentials),
      );
      // Update Authorization header
      axios.defaults.headers.common.Authorization = `Bearer ${response.data.access}`;
      originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
      return axiosInstance(originalRequest);
    }
  } catch (error) {
    clearLocalStorage();
    sessionStorage.clear();
    window.location.href = '/sign-in';
    throw new Error(error);
  }
  return null;
};

export default refresh;
